const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.58,
    height: 21.11,
    viewBox: "0 0 52.58 21.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M51.55,12.35c.29-1.03-.26-2.67-.26-2.67l-1.54-1.01-11.28-1.52c-.24-.59-.9-.61-.9-.61L31.29,1.03c-.9-.48-1.29-.49-1.29-.49C24.82-.37,6.4,.14,6.4,.14c-.58-.01-1.18,.56-1.18,.56-.4,.25-.01,.52-.01,.52L1.76,6.14c-.59,.31-.75,1.28-.75,1.28-.16,1.17,.03,3.77,.03,3.77l-.59,.18c-.27,.32,.11,.98,.11,.98l-.26,.06c-.26,.06-.29,1.03-.29,1.03-.08,.52,.37,.79,.37,.79l-.09,1.04,3.83,.36,3.36,.87c.39-5.19,5.47-5.52,5.47-5.52,5.2,.07,5.51,5.73,5.51,5.73l20.99,.6c.74-6.03,5.74-5.9,5.74-5.9,5.52,.27,4.59,6.04,4.59,6.04,.65,.15,.85-.04,.85-.04l.08-.78c.86-.43,1.72-1.26,1.72-1.26l.13-2.53c-.12-.46-1.03-.48-1.03-.48h0ZM1.3,11.33s-.33-2.22-.18-3.19c0,0,2.21,.12,2.66,.13v3.06s-2.48,0-2.48,0ZM12.55,6.09l-6.89-.18L8.17,1.81s.47-.57,1.39-.75l3.38,.02-.39,5ZM22.63,1.19l.83,5.56-8.77-.42,.06-4.43v-.72h2.86m15.53,5.87l-8.01-.15-1.07-5.73s-.72,.05,0,0l4.32,.03c.79,.08,1.54,.36,2.18,.84,.73,.54,1.48,1.75,2.96,3l-.4,.38,.02,1.63Zm18.14,5.54l-1.36-.1,.06-2.41,1.17-.04c0,.06,.36,1.18,.13,2.54h0Z",
    style: {
      fill: "#161513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.84,12.49c-2.36,.04-4.27,2.02-4.23,4.38s2.02,4.27,4.38,4.23,4.27-2.02,4.23-4.38c-.04-2.37-2.02-4.27-4.38-4.23Z",
    style: {
      fill: "#c1966f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.72,12.37c-2.4,.04-4.33,2.04-4.29,4.44s2.04,4.33,4.44,4.29,4.33-2.04,4.29-4.44c-.04-2.4-2.04-4.33-4.44-4.29Z",
    style: {
      fill: "#c1966f"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuv);
export default __webpack_public_path__ + "static/media/suv.72f96a721c028754231564aa59932c55.svg";
export { ForwardRef as ReactComponent };